import { render, staticRenderFns } from "./NewsAddNew.vue?vue&type=template&id=1b55fe8a&scoped=true"
import script from "./NewsAddNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsAddNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewsAddNew.vue?vue&type=style&index=0&id=1b55fe8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b55fe8a",
  null
  
)

export default component.exports